export default __webpack_public_path__ + "static/media/squares300.434c39e5.jpg";